import { Icon, IconName } from '@components/common/icons'
import { IntentType } from '@lib/types/common'
import classNames from 'classnames'
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'
type AlertMessageProps = DetailedHTMLProps<
  HTMLAttributes<HTMLParagraphElement>,
  HTMLParagraphElement
> & {
  children?: React.ReactNode
  type?: IntentType
  /**
   * icon can either be a string or an element
   */
  icon?: IconName
}

const alertMessageStyles = {
  danger: 'border-red-200 bg-red-50 text-red-200',
  info: 'border-blue-200 bg-blue-50 text-blue-200',
  warning: 'border-yellow-200 bg-yellow-50 text-yellow-200',
  success: 'border-green-200 bg-green-50 text-green-200',
}

const AlertMessage = ({
  children,
  className,
  type = 'danger',
  icon,
  ...props
}: AlertMessageProps) => {
  return (
    <p
      className={classNames(
        'flex items-center my-1 border-l-4 text-sm  pl-1 pr-5 py-1 font-500',
        alertMessageStyles[type],
        className
      )}
      {...props}
    >
      {/*
        if icon is a string then render a feather-icon
      */}
      {icon ? (
        typeof icon === 'string' ? (
          <Icon className="mr-1" name={icon} size={16} />
        ) : (
          icon
        )
      ) : null}
      <span className="ml-1">{children}</span>
    </p>
  )
}

export default AlertMessage
